export default "__VITE_ASSET__De4Y4M2Y__"